module.exports = __webpack_public_path__ + "media/images/img-hobby-9-e48a92df.jpg";